<template>
  <div>
    <el-table :data="urllist" style="width: 100%" height="630">
      <el-table-column label="id">
        <template slot-scope="scope">
          <!-- <i class="el-icon-time"></i> -->
          <span style="margin-left: 10px">{{ scope.row.id }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="tenantName" label="租户名称" />

      <el-table-column label="lineUrl">
        <template slot-scope="scope">
          <div slot="reference" class="name-wrapper">
            <span>{{ scope.row.lineUrl }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="zh">
        <template slot-scope="scope">
          <!-- <el-popover trigger="hover" placement="top"> -->
          <!-- <p>姓名: {{ scope.row.name }}</p>
          <p>住址: {{ scope.row.address }}</p> -->
          <div slot="reference" class="name-wrapper">
            <span>{{ scope.row.zh }}</span>
          </div>
          <!-- </el-popover> -->
        </template>
      </el-table-column>
      <el-table-column label="en">
        <template slot-scope="scope">
          <!-- <el-popover trigger="hover" placement="top"> -->
          <!-- <p>姓名: {{ scope.row.name }}</p>
          <p>住址: {{ scope.row.address }}</p> -->
          <div slot="reference" class="name-wrapper">
            <span>{{ scope.row.en }}</span>
          </div>
          <!-- </el-popover> -->
        </template>
      </el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          <div slot="reference" class="name-wrapper">
            <el-switch
              active-color="#13ce66"
              @change="handleCodeStatusChange(scope.row, $event)"
              :value="scope.row.status ? true : false"
            ></el-switch>
          </div>
          <!-- </el-popover> -->
        </template>
      </el-table-column>

      <el-table-column label="测速" width="160">
        <template slot-scope="scope">
          <span v-if="getSpeedResult(scope.row.id).loading" class="speed-loading">
            测速中...
          </span>
          <span
            v-else-if="getSpeedResult(scope.row.id).ms !== undefined"
            :style="{ color: getSpeedResult(scope.row.id).ok ? '#67c23a' : '#f56c6c' }"
          >
            {{
              getSpeedResult(scope.row.id).ok
                ? `${getSpeedResult(scope.row.id).ms}ms`
                : getSpeedResult(scope.row.id).error
            }}
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="primary"
            circle
            icon="el-icon-edit"
            @click="handleEdit(scope.$index, scope.row)"
          ></el-button>
          <el-button
            size="small"
            type="danger"
            circle
            icon="el-icon-delete"
            @click="handleDelete(scope.$index, scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      title="修改app链接"
      width="800px"
      :visible.sync="dialogVisibleChange"
      @close="closeDialog"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="链接zh" prop="zh">
          <el-input
            v-model="ruleForm.zh"
            placeholder="请输入链接名称(中文)"
          ></el-input>
        </el-form-item>
        <el-form-item label="链接en" prop="en">
          <el-input
            v-model="ruleForm.en"
            placeholder="请输入链接名称(英文)"
          ></el-input>
        </el-form-item>
        <el-form-item label="链接地址" prop="lineUrl">
          <el-input
            v-model="ruleForm.lineUrl"
            placeholder="请输入链接地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="测速类型">
          <el-select v-model="speedTestType" style="width: 220px">
            <el-option
              v-for="item in speedTestOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <el-button
            style="margin-left: 8px"
            :loading="speedTesting"
            :disabled="!ruleForm.lineUrl"
            @click="handleSpeedTest"
            >测速</el-button
          >
        </el-form-item>
        <el-form-item v-if="speedResult" label="测速结果">
          <span :style="{ color: speedResult.ok ? '#67c23a' : '#f56c6c' }">
            {{
              speedResult.ok
                ? `成功 ${speedResult.ms}ms（HTTP ${speedResult.status}）`
                : `失败：${speedResult.error}`
            }}
          </span>
        </el-form-item>
        <el-form-item label="租户选择" prop="tenantId">
          <el-select
            disabled
            v-model="ruleForm.tenantId"
            placeholder="租户选择"
            clearable
          >
            <el-option
              v-for="item in tenantList"
              :key="item.id"
              :label="item.tenantName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="状态" prop="status">
          <!-- <el-input v-model="ruleForm.status" ></el-input> -->

          <el-tooltip
            class="item"
            effect="dark"
            content="绿色为启用，红色则为未启用"
            placement="right"
          >
            <el-switch
              v-model="ruleForm.status"
              active-color="#13ce66"
              inactive-color="#ff4949"
            ></el-switch>
          </el-tooltip>
        </el-form-item>

        <el-form-item label-width="300px">
          <el-button type="primary" @click="updateUrL('ruleForm')"
            >确定修改</el-button
          >
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave('currencyForm')"
          >保存</el-button
        > -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
import { ValidateLineUrl } from "../../validate";
import { tenantInfo } from "@/common/publicApi";
import {
  SPEED_TEST_OPTIONS,
  buildSpeedTestUrl,
  runSpeedTest,
} from "../../speedTest";
export default {
  data() {
    return {
      dialogVisibleChange: false,
      speedTestType: "inspectsurvival",
      speedTestOptions: SPEED_TEST_OPTIONS,
      speedTesting: false,
      speedResult: null,
      result: true,
      ruleForm: {},
      upperList: [],
      tenantList: [],
      rules: {
        zh: [
          {
            required: true,
            trigger: "blur",
          },
          { message: "不能为空", trigger: "blur" },
        ],
        en: [
          { required: true, trigger: "blur" },
          { message: "不能为空", trigger: "blur" },
        ],

        lineUrl: [
          {
            required: true,
            validator: ValidateLineUrl,
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    tenantInfo().then((res) => {
      if (res.code == 0) {
        this.tenantList = res.data;
      }
    });
    this.getDataList();
  },
  computed: {
    ...mapState("appLineUrl", ["codelist", "urllist", "speedResultMap"]),
    ...mapGetters("appLineUrl", ["filterList"]),
    list() {
      return this.filterList.map((item) => item.locale.toUpperCase());
    },
  },
  methods: {
    getSpeedResult(id) {
      return this.speedResultMap[id] || {};
    },
    ...mapActions("appLineUrl", [
      "getlist",
      "delOne",
      "updateOne",
      "getUrlList",
    ]),
    async getDataList() {
      const res = await this.getUrlList({ page: 1, size: 10, lineUrl: "" });
      // this.codelist=res.data.list
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    resetSpeedTestState() {
      this.speedTestType = "inspectsurvival";
      this.speedTesting = false;
      this.speedResult = null;
    },
    async handleSpeedTest() {
      if (!this.ruleForm.lineUrl) {
        this.$message.warning("请先填写线路地址");
        return;
      }
      this.speedTesting = true;
      this.speedResult = null;
      const url = buildSpeedTestUrl(this.ruleForm.lineUrl, this.speedTestType);
      const result = await runSpeedTest(url);
      this.speedResult = result;
      this.speedTesting = false;
      if (result.ok) {
        this.$message.success(`测速成功：${result.ms}ms`);
      } else {
        this.$message.error(result.error || "测速失败");
      }
    },
    handleEdit(index, row) {
      this.resetSpeedTestState();
      this.dialogVisibleChange = true;
      this.ruleForm = { ...this.ruleForm, ...row, status: Boolean(row.status) };
    },
    handleDelete(index, row) {
      const id = row.id;
      this.$confirm("确定要删除该链接地址吗？", "提示", {
        type: "warning",
      }).then(async () => {
        const res = await this.delOne(id);
        if (res.code == 0) {
          this.$message.success("操作成功");
          this.getDataList();
        } else {
          this.$message.error("操作失败！请重试");
        }
      });
    },

    handleCodeStatusChange(row, status) {
      const message = status
        ? "确认要开启当前Url状态吗？"
        : "确认要关当前Url？关闭该Url，相应的选项也将关闭。";

      this.$confirm(message, "提示", { type: "warning" }).then(async () => {
        if (!row.status) {
          row.status = true;
          const res = await this.updateOne(row);
          if (res.data == 0) {
            this.$message.success("操作成功");
          }
        } else if (row.status) {
          row.status = false;
          const res = await this.updateOne(row);
          if (res.data == 0) {
            this.$message.success("操作成功");
          }
        }
      });
    },
    updateUrL(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.ruleForm.status = Number(this.ruleForm.status);

          const res = await this.updateOne(this.ruleForm);
          if (res.code == 0) {
            this.$message.success("操作成功");
            this.dialogVisibleChange = false;
            this.getDataList();
            this.result = true;
          }
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.resetSpeedTestState();
    },
    closeDialog() {
      this.resetSpeedTestState();
    },
  },
};
</script>

<style lang="less" scoped>
.speed-loading {
  color: #909399;
}
</style>
